import React from 'react'
import {
  Box,
  Typography,
} from '@material-ui/core'
import {
  AddCircle as AddCircleIcon,
  RemoveCircle as RemoveCircleIcon,
} from '@material-ui/icons'

const SlotControl = props => {

  return (
    <Box className={props.classes.slotControl}>
      <Typography variant='h5' component='div' className={props.classes.slotLength}>
        {props.label}
      </Typography>
      <Box>
        <RemoveCircleIcon className={props.classes.iconControl}
          onClick={props.onClickRemove}
        />
        &nbsp;&nbsp;
        {props.labelIcon}
        &nbsp;&nbsp;
        <AddCircleIcon className={props.classes.iconControl}
          onClick={props.onClickAdd}
        />
      </Box>
    </Box>
  )
}
export default SlotControl